import { useState } from "react";

const apiUrl = process.env.REACT_APP_API_URL;

/**
 * Custom hook for resending the email-verification link.
 * @returns {{ loading: boolean, message: { type: string, text: string }, resendVerification: Function }}
 */
export const useResendVerification = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  /**
   * @param {Object}   param
   * @param {string}   param.email — User's email address
   */
  const resendVerification = async ({ email }) => {
    setLoading(true);
    setMessage({ type: "", text: "" });

    try {
      const response = await fetch(`${apiUrl}/auth/email/resend`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage({
          type: "success",
          text:
            "Verification email resent successfully. If you don't see it in your inbox, please check your spam or junk folder."
        });
      } else {
        const errMsg =
          data?.errors?.email?.[0] ||
          data?.message ||
          "Failed to resend email.";
        setMessage({ type: "error", text: errMsg });
      }
    } catch {
      setMessage({
        type: "error",
        text: "Something went wrong. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    message,
    setMessage,
    resendVerification,
  };
};
